module.exports = __webpack_public_path__ + "img/5-1_03.ef0925a0.jpg";